// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwCommandPanelSection from 'viewmodel/AwCommandPanelSectionViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import DesCatalogCarousel from 'viewmodel/DesCatalogCarouselViewModel';
    import { ExistWhen } from 'js/hocCollection';
const AwFlexColumnExistWhen = ExistWhen(AwFlexColumn);
const AwFlexRowExistWhen = ExistWhen(AwFlexRow);
const AwPanelSectionExistWhen = ExistWhen(AwPanelSection);
AwFlexColumnExistWhen.displayName = 'AwFlexColumnExistWhen';
AwFlexRowExistWhen.displayName = 'AwFlexRowExistWhen';
AwPanelSectionExistWhen.displayName = 'AwPanelSectionExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogPartSummaryService', () => import('js/DesCatalogPartSummaryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onMount": "changeViewer"
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "attachments": {
            "type": "string"
        },
        "partid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "hideelements": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        }
    },
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "manufacturer": {
            "displayName": "{{i18n.manufacturer}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "partNo": {
            "displayName": "{{i18n.partNo}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "propertiesLabel": {
            "displayName": "{{i18n.properties}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false"
        },
        "viewList": {
            "displayName": "Viewer",
            "name": "viewList",
            "type": "STRING",
            "isRequired": false,
            "dataProvider": "viewListProvider"
        },
        "downloadButtonCommand": {
            "action": "downloadAction",
            "iconName": "cmdDownload24"
        },
        "previousPreviewButtonCommand": {
            "action": "previousPreviewAction",
            "iconName": "miscChevronLeft24"
        },
        "nextPreviewButtonCommand": {
            "action": "nextPreviewAction",
            "iconName": "miscChevronRight16"
        },
        "loadColumn": [
            {
                "name": "name",
                "displayName": "{{i18n.name}}",
                "maxWidth": 380,
                "minWidth": 260,
                "width": 340,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "value",
                "displayName": "{{i18n.value}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 390,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "renderingHint": "CustomLOVComponent",
                "pinnedLeft": true
            }
        ],
        "showDownloadPopup": false,
        "showWebglView": false,
        "checkForResetSelection": false,
        "command": "des_resetPartFamilyConfiguration",
        "webglViewerSrc": "",
        "pdfViewerSrc": "",
        "imageViewerSrc": "",
        "pageSize": 40,
        "_constants": {
            "PROPERTIES": "properties",
            "PART_CONFIGURATION": "configuration",
            "PREVIEW": "preview"
        },
        "defaultPreview": {
            "dbValue": ""
        },
        "isPropsUpdated": false,
        "refreshTableLov": false,
        "getFeatureGroupInput": {},
        "changeCount": 0,
        "displayView": {
            "type": "STRING",
            "dbValue": ""
        },
        "ViewerSrc": {
            "type": "STRING"
        }
    },
    "grids": {
        "partSummaryTable": {
            "dataProvider": "partSummaryTableRowProvider",
            "columnProvider": "partSummaryTableColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enablePinning": true,
                "enableSorting": false
            }
        }
    },
    "actions": {
        "listProductsForFeatureGroup": {
            "actionType": "JSFunction",
            "method": "updateVmoByName",
            "inputData": {
                "vmo": "{{data}}",
                "name": "listProductForFeatureGroup",
                "val": true
            },
            "outputData": {
                "refreshTableLov": "refreshTableLov"
            },
            "events": {
                "success": [
                    {
                        "name": "refreshSublocation"
                    }
                ]
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "loadSummary": {
            "actionType": "JSFunctionAsync",
            "method": "loadPartDetails",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "outputData": {
                "part": "part",
                "output": "output",
                "partSummary": "propertiesOfPart",
                "propertiesOfPart": "propertiesOfPart",
                "inputsForFeatureGroup": "inputsForFeatureGroup",
                "webglViewerSrc": "webGlSrc",
                "pdfViewerSrc": "pdfjsSrc",
                "viewerInfo": "viewerInfo",
                "allViewersInfo": "allViewersInfo",
                "editConfig": "editConfig",
                "filterResults": "{{function:processResults}}"
            },
            "events": {
                "success": [
                    {
                        "name": "updatePartPropertiesConfig"
                    },
                    {
                        "name": "updateAllViewersSRC",
                        "eventData": {
                            "eventName": "updateAllViewersSRC",
                            "eventData": "{{allViewersInfo}}"
                        }
                    },
                    {
                        "name": "loadSummary.success",
                        "condition": "data.refreshTableLov === false"
                    },
                    {
                        "name": "updatePartProperties",
                        "condition": "data.refreshTableLov === false"
                    },
                    {
                        "name": "ConfigureTableValues",
                        "condition": "data.refreshTableLov === true"
                    },
                    {
                        "name": "loadSummary.applyConfig.success",
                        "condition": "data.listProductForFeatureGroup === true"
                    }
                ]
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "getWebglSrc": {
            "actionType": "JSFunction",
            "method": "getWebglViewerSrcString",
            "inputData": {
                "vmo": "{{data}}",
                "viewerSrc": "{{parameters.eventData}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "startEditAction": {
            "actionType": "dataProvider",
            "method": "partSummaryTableRowProvider",
            "inputData": {
                "action": "startEdit"
            }
        },
        "splmTableStartEdit": {
            "actionType": "JSFunction",
            "method": "splmTableStartEditConfig",
            "inputData": {
                "data": "{{data.editConfig.startEditConfig}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "cancelEditAction": {
            "actionType": "dataProvider",
            "method": "partSummaryTableRowProvider",
            "inputData": {
                "action": "cancelEdits"
            }
        },
        "doRegisterSelectedObject": {
            "actionType": "JSFunction",
            "method": "registerSelectedObject",
            "inputData": {
                "selectedObjects": "{{parameters.eventData}}"
            },
            "outputData": {
                "previousLOVvalue": "previousLOVvalue"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "performBatchActionOnLOVSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getFeatureGroupValuesInputForProduct"
                }
            ]
        },
        "getFeatureGroupValuesInputForProduct": {
            "actionType": "JSFunctionAsync",
            "method": "getFeatureGroupValuesInput",
            "inputData": {
                "inputFeatureData": "{{parameters.eventData}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "inputValuesOfFeatureGroup": "inputValuesOfFeatureGroup"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "partSummaryTableRowProvider"
        },
        "resetPartConfigBatchActions": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "updateCancelEditActionFlag"
                },
                {
                    "action": "cancelEditAction"
                },
                {
                    "action": "reveal"
                },
                {
                    "action": "executePostResetConfig"
                }
            ]
        },
        "refreshFeatureGroup": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "updateLovChangeFlag",
                    "inputArgs": {
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "updateCancelEditActionFlag": {
            "actionType": "JSFunctionAsync",
            "method": "updateCancelEditActionFlag",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "executePostResetConfig": {
            "actionType": "JSFunctionAsync",
            "method": "executePostResetConfig",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "updateProperties": {
            "actionType": "JSFunction",
            "method": "SetProperties",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "part": "{{data.part}}",
                "invokedFrom": "part-summary"
            },
            "outputData": {
                "isPropsUpdated": "partPropsUpdated"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "updateLovChangeFlag": {
            "actionType": "JSFunction",
            "method": "updateConfigLovChnagedFlag",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{parameters.eventData}}"
            },
            "outputData_old": {
                "refreshTableLov": "refreshTableLov",
                "getFeatureGroupInput": "getFeatureGroupInput"
            },
            "events1": {
                "success": [
                    {
                        "action": "reveal",
                        "condition": "data.refreshTableLov === true"
                    }
                ]
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "applyConfigBatchActions": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "cancelEditAction"
                },
                {
                    "action": "listProductsForFeatureGroup"
                }
            ]
        },
        "applyConfigSuccess": {
            "actionType": "JSFunction",
            "method": "onAfterApplyConfig",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "updatePartPropertiesConfig": {
            "actionType": "JSFunction",
            "method": "updatePartPropertiesConfig",
            "inputData": {
                "vmo": "{{data.propertiesOfPart}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "showNextViewer": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "nextViewer"
                },
                {
                    "action": "changeViewer"
                }
            ]
        },
        "showPreviousViewer": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "previousViewer"
                },
                {
                    "action": "changeViewer"
                }
            ]
        },
        "changeViewer": {
            "actionType": "JSFunction",
            "method": "changeViewer",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "previousViewer": {
            "actionType": "JSFunction",
            "method": "previousViewer",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "nextViewer": {
            "actionType": "JSFunction",
            "method": "nextViewer",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        }
    },
    "dataProviders": {
        "partSummaryTableRowProvider": {
            "action": "loadSummary",
            "initializeAction": "loadSummary",
            "response": "{{data.filterResults}}",
            "moreValuesExist": false,
            "totalFound_old": "{{data.totalFound}}",
            "totalFound_old1": "{{data.filterResults.length}}",
            "editConfig": {
                "startEditAction": "splmTableStartEdit",
                "saveEditAction": "splmTableSaveEdit",
                "identifier": "uid"
            }
        },
        "viewListProvider": {
            "propDisplayValue": "{{data.partSummary.name}}",
            "dispValue": "{{data.partSummary.name}}",
            "propInternalValue": "{{data.partSummary.name}}"
        }
    },
    "columnProviders": {
        "partSummaryTableColumnProvider": {
            "frozenColumnIndex": -1,
            "columns": "{{data.loadColumn}}"
        }
    },
    "onEvent": [
        {
            "eventId": "updatePartPropertiesConfig",
            "action": "updatePartPropertiesConfig"
        },
        {
            "eventId": "lovChanged.refreshTable",
            "action": "reveal"
        },
        {
            "eventId": "desWebGlViewer",
            "action": "getWebglSrc",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "ConfigureTableValues",
            "action": "startEditAction"
        },
        {
            "eventId": "resetPartConfig.initiated",
            "action": "resetPartConfigBatchActions"
        },
        {
            "eventId": "partSummaryTableRowProvider.selectionChangeEvent",
            "cacheEventData": false,
            "action": "doRegisterSelectedObject",
            "inputArgs": {
                "eventName": "partSummaryTableRowProvider.selectionChangeEvent",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "applyPartConfig.initiated",
            "action": "applyConfigBatchActions"
        },
        {
            "eventId": "updatePartProperties",
            "action": "updateProperties",
            "condition_commented": "conditions.isPropsUpdated"
        },
        {
            "eventId": "des-feature-group.selectionChange",
            "action": "refreshFeatureGroup",
            "cacheEventData": false,
            "inputArgs": {
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "des-feature-group.invalidSelection",
            "message": "desInvalidFeatureGroupSelection"
        },
        {
            "eventId": "refreshSublocation",
            "action": "reveal"
        },
        {
            "eventId": "partConfigCancel.initiated",
            "action": "cancelEditAction"
        },
        {
            "eventId": "applyPartConfig.error",
            "message": "desInvalidFeatureGroupSelectionWithName"
        },
        {
            "eventId": "loadSummary.applyConfig.success",
            "action": "applyConfigSuccess"
        }
    ],
    "functions": {
        "processResults": {
            "functionName": "processResults",
            "parameters": [
                "{{data.dataProviders.partSummaryTableRowProvider.startIndex}}",
                "{{data.pageSize}}",
                "{{data}}"
            ],
            "deps": "js/DesCatalogPartSummaryService"
        }
    },
    "conditions": {
        "isLOVChanged": {
            "expression": "data.previousLOVvalue !== data.inputValuesOfFeatureGroup.propDisplayValue"
        },
        "enableProperties": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PROPERTIES) > -1)"
        },
        "enablePreview": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PREVIEW) > -1)"
        },
        "enableConfiguration": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PART_CONFIGURATION) > -1)"
        },
        "isPropsUpdated": {
            "expression": "( data.isPropsUpdated === false )"
        },
        "enableDefaultPreview": {
            "expression": "( data.defaultPreview.dbValue.length > 1  )"
        },
        "enableWebglPreview": {
            "expression": "( data.showWebglView === true && data.webglViewerSrc.length > 0 )"
        }
    },
    "i18n": {
        "partConfiguration": [
            "DesCatalogPartSummaryMessages"
        ],
        "name": [
            "DesCatalogPartSummaryMessages"
        ],
        "value": [
            "DesCatalogPartSummaryMessages"
        ],
        "preview": [
            "DesCatalogPartSummaryMessages"
        ],
        "manufacturer": [
            "DesCatalogPartSummaryMessages"
        ],
        "partNo": [
            "DesCatalogPartSummaryMessages"
        ],
        "invalidLovSelection": [
            "DesCatalogPartSummaryMessages"
        ],
        "invalidFeatureGroupSelectionWithName": [
            "DesCatalogPartSummaryMessages"
        ],
        "properties": [
            "DesCatalogPartSummaryMessages"
        ]
    },
    "messages": {
        "desInvalidFeatureGroupSelection": {
            "messageType": "ERROR",
            "messageText": "{{i18n.invalidLovSelection}}"
        },
        "desInvalidFeatureGroupSelectionWithName": {
            "messageType": "ERROR",
            "messageText": "{{i18n.invalidFeatureGroupSelectionWithName}}",
            "messageTextParams": [
                "{{ctx.invalidFeatureGroupSelection.featureGroup.propInternalValue}}"
            ]
        }
    },
    "_viewModelId": "DesCatalogPartSummary",
    "_uniqueViewModelId": "DesCatalogPartSummary",
    "ctx": {
        "invalidFeatureGroupSelection": {
            "type": "object"
        }
    }
};

    /*
    <div class="des-catalog-part-summary-styling">
    <aw-panel class="des-catalog-part-summary-styling">
        <aw-panel-body>
            <aw-flex-row height="12" width="12">
                <aw-flex-column width="{{conditions.enablePreview ? 6 : 12}}"
                    exist-when="(conditions.enableConfiguration || conditions.enableProperties)">
                    <aw-flex-row height="fill" exist-when="conditions.enableProperties">
                        <aw-panel-section caption="{{i18n.properties}}">
                            <aw-label prop="data.name"></aw-label>
                            <aw-label prop="data.manufacturer"></aw-label>
                            <aw-label prop="data.partNo"></aw-label>
                        </aw-panel-section>
                    </aw-flex-row>
                    <aw-flex-row height="fill" exist-when="conditions.enableConfiguration">
                        <aw-command-panel-section caption="{{i18n.partConfiguration}}" anchor="data.command"
                            show-command-labels="true" class="sectionContent">
                            <aw-panel-body>
                                <aw-splm-table gridid="partSummaryTable"></aw-splm-table>
                            </aw-panel-body>
                        </aw-command-panel-section>
                    </aw-flex-row>
                </aw-flex-column>

                <aw-flex-column class="des-part-preview-container" width="6" exist-when="conditions.enablePreview">
                    <div class="des-catalog-part-summary-panel-section-styling">
                        <aw-panel-section caption="{{i18n.preview}}" exist-when="conditions.enableDefaultPreview"
                            height="12">
                            <aw-flex-row height="12">
                                <des-catalog-carousel allViewersSRC={{data.data.viewerInfo}}
                                    accsessionid={{props.accsessionid}}></des-catalog-carousel>
                            </aw-flex-row>
                        </aw-panel-section>
                    </div>
                </aw-flex-column>

            </aw-flex-row>
        </aw-panel-body>
    </aw-panel>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="des-catalog-part-summary-styling">
        <AwPanel  revealAction={actions.reveal}  className="des-catalog-part-summary-styling">
            <AwPanelBody>
                <AwFlexRow height="12" width="12">
                    <AwFlexColumnExistWhen width={AwParseService.instance( "conditions.enablePreview ? 6 : 12" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} existWhen={AwParseService.instance( "(conditions.enableConfiguration || conditions.enableProperties)" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "conditions.enableProperties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            <AwPanelSection caption={AwParseService.instance( "i18n.properties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                <AwLabel {...getField("data.name", fields, $index, null, null )}>
                                </AwLabel>
                                <AwLabel {...getField("data.manufacturer", fields, $index, null, null )}>
                                </AwLabel>
                                <AwLabel {...getField("data.partNo", fields, $index, null, null )}>
                                </AwLabel>
                            </AwPanelSection>
                        </AwFlexRowExistWhen>
                        <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "conditions.enableConfiguration" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            <AwCommandPanelSection caption={AwParseService.instance( "i18n.partConfiguration" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} anchor={AwParseService.instance( "data.command" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} show-command-labels="true" className="sectionContent">
                                <AwPanelBody>
                                    <AwSplmTable {...grids.partSummaryTable}>
                                    </AwSplmTable>
                                </AwPanelBody>
                            </AwCommandPanelSection>
                        </AwFlexRowExistWhen>
                    </AwFlexColumnExistWhen>
                    <AwFlexColumnExistWhen className="des-part-preview-container" width="6" existWhen={AwParseService.instance( "conditions.enablePreview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <div className="des-catalog-part-summary-panel-section-styling">
                            <AwPanelSectionExistWhen caption={AwParseService.instance( "i18n.preview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} height="12" existWhen={AwParseService.instance( "conditions.enableDefaultPreview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                <AwFlexRow height="12">
                                    <DesCatalogCarousel allviewerssrc={AwParseService.instance( "data.data.viewerInfo" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                    </DesCatalogCarousel>
                                </AwFlexRow>
                            </AwPanelSectionExistWhen>
                        </div>
                    </AwFlexColumnExistWhen>
                </AwFlexRow>
            </AwPanelBody>
        </AwPanel>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;